import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { Product } from 'src/app/models/product';
import { PermissionsService } from 'src/app/services/permissions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  public products:Product[] = [];
  public productsTemp:Product[] = [];
  public loading = false;
  public product:Product = new Product();
  public expand:boolean = false;

  public actEditProd:boolean = true;
  public actAddProd:boolean = true;
  public actDeleteProd:boolean = true;
  public actPermProd:boolean = true;

  //Pagination
  public page:number = 1;
  public pagination:number = 20;

  //Searching
  public find:string = '';

  constructor(private productServ:ProductService, private permService:PermissionsService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private toastr: ToastrManager) { }

  async ngOnInit() {
    this.getProducts();
    this.actEditProd = this.authService.can("update-product");
    this.actDeleteProd = this.authService.can("destroy-product");
    this.actAddProd = this.authService.can("store-product");
  }

  async getProducts() {
    this.loading = true;
    this.products = await this.productServ.getProducts();
    this.filter();
    this.loading = false;
  }

  filter(){
    this.utl.search(this.products, ['id', 'name', 'division'], this.find, 'id', products => this.productsTemp = products);
  }

  select(modal?, product?:Product) {
    if(product) {
      this.product = product;
    } else {
      this.product = new Product();
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  async updateProduct() {
    try {
      this.loading = true;
      let product = await this.productServ.putProduct(this.product);
      this.find = '';
      await this.getProducts();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El producto se ha actualizado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async storeProduct() {
    try {
      this.loading = true;
      let product = await this.productServ.postProduct(this.product);
      this.find = '';
      await this.getProducts();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El producto se ha creado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async deleteProduct() {
    try {
      this.loading = true;
      let product = await this.productServ.deleteProduct(this.product);
      this.find = '';
      await this.getProducts();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El producto se ha eliminado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }
}
